import * as React from "react";
import { IconProps } from "common/assets/icons/types";

export const AskQuestionIcon: React.FC<IconProps> = ({ color = "#fd6a65" }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h32v32H0z" />
        <g fill={color}>
          <path
            d="M15.75 24.75a9 9 0 1 0-9-9c0 1.091.265 2.183.601 3.13.527 1.479.79 2.219.816 2.639.03.472.008.65-.136 1.1-.128.402-.438.866-1.056 1.794l-.225.337h9Z"
            fillRule="nonzero"
            opacity=".12"
          />
          <path d="M15.75 7.5a8.25 8.25 0 0 0-8.25 8.25c0 .977.238 1.98.558 2.878l.005.014c.259.728.46 1.292.598 1.726.135.422.235.792.255 1.104.015.25.02.467-.008.697-.028.23-.087.44-.163.679-.09.284-.235.56-.416.859-.056.091-.117.189-.184.293h7.605a8.25 8.25 0 1 0 0-16.5ZM6 15.75C6 10.365 10.365 6 15.75 6s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75h-9a.75.75 0 0 1-.624-1.166l.225-.337c.313-.47.534-.802.694-1.067.16-.264.234-.421.271-.538a2.24 2.24 0 0 0 .104-.407 2.24 2.24 0 0 0-.001-.419c-.007-.108-.052-.319-.187-.741-.13-.408-.322-.95-.587-1.694C6.29 18.136 6 16.956 6 15.75Zm10.75 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-2.25-6a1.25 1.25 0 1 1 2.5 0v.121c0 .364-.145.713-.402.97L15.22 16.22a.75.75 0 1 0 1.06 1.06l1.379-1.378a2.871 2.871 0 0 0 .841-2.03v-.122a2.75 2.75 0 1 0-5.5 0v.5a.75.75 0 0 0 1.5 0v-.5Z" />
        </g>
      </g>
    </svg>
  );
};
